document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".before-after");

  if (!sliders.length) return;

  sliders.forEach(container => {
    const afterImage = container.querySelector(".after-image");
    const sliderHandle = container.querySelector(".slider-handle");

    if (!afterImage || !sliderHandle) return;

    const handleDot = sliderHandle.querySelector(".handle-dot");
    const radius = handleDot ? handleDot.offsetWidth / 2 : 10; // 圆点半径一半
    let isDragging = false;

    const updateSlider = (x) => {
      const rect = container.getBoundingClientRect();
      // 限制滑块位置，保证圆点不被裁剪
      let offsetX = Math.min(Math.max(x - rect.left, radius), rect.width - radius);
      let percent = (offsetX / rect.width) * 100;

      afterImage.style.clipPath = `inset(0 0 0 ${percent}%)`;
      sliderHandle.style.left = `${percent}%`;
    };

    // 鼠标事件
    sliderHandle.addEventListener("mousedown", (e) => {
      e.preventDefault();
      isDragging = true;
      sliderHandle.classList.add("active");
    });
    window.addEventListener("mouseup", () => {
      isDragging = false;
      sliderHandle.classList.remove("active");
    });
    window.addEventListener("mousemove", (e) => {
      if (isDragging) updateSlider(e.clientX);
    });

    // 触屏事件
    sliderHandle.addEventListener("touchstart", (e) => {
      isDragging = true;
      sliderHandle.classList.add("active");
    });
    window.addEventListener("touchend", () => {
      isDragging = false;
      sliderHandle.classList.remove("active");
    });
    window.addEventListener("touchmove", (e) => {
      if (isDragging && e.touches.length > 0) {
        updateSlider(e.touches[0].clientX);
      }
    });

    // 初始化位置到 50%
    const initPercent = 50;
    afterImage.style.clipPath = `inset(0 0 0 ${initPercent}%)`;
    sliderHandle.style.left = `${initPercent}%`;
  });
});

